
import { getS3JsonData } from '@/services/httpClientHelper.js'


// STATIC calls 

export const sasEnviroments = async() => getS3JsonData('sas/sasEnviroments/enviroments.json').then(response => {  
    return response?.data
})

export const sasEnviromentsViya4 = async() => getS3JsonData('sas/sasEnviroments/enviromentsViya4.json').then(response => {  
    return response?.data
})

export const paAnnouncements = async() => getS3JsonData('pa/announcements.json').then(response => {  
    return response?.data
})

export const homeInfo = async() => getS3JsonData('home/homeInfo.json').then(response => {  
    return response?.data
})

export const tpdAllDxcNumbers = async() => getS3JsonData('tpd/dxc/allDxcNumbers.json').then(response => {
    return response?.data
})

export const tpdEcusWithDtcs = async() => getS3JsonData('tpd/ecu/dtc_ecu.json').then(response => {
    return response?.data
})

export const tpdAllEcus = async() => getS3JsonData('tpd/ecu/all_ecu.json').then(response => {
    return response?.data
})

export const tpdProducts = async() => getS3JsonData('tpd/products.json').then(response => {
    return response?.data
})

export const tpdUsers = async() => getS3JsonData('tpd/users.json').then(response => {
    return response?.data
})

export const tpdAllGenerations = async() => getS3JsonData('tpd/ecu/all_generations.json').then(response => {
    return response?.data
})

export const tpdDxcClassificationTypes = async() => getS3JsonData('tpd/dxc/tpdDxcClassificationTypes.json').then(response => {  
    return response?.data
})

export const tpdInteClassificationTypes = async() => getS3JsonData('tpd/inte/tpdInteClassificationTypes.json').then(response => {  
    return response?.data
})

export const tpdInfo = async() => getS3JsonData('tpd/tpdInfo.json').then(response => {  
    return response?.data
})

export const navistarSpecification = async() => getS3JsonData('variants/navistar/navistarSpecification_20221005T123000Z.json').then(response => {  
    return response?.data
})

export const vehicleGetFpcFamiliesAll = async() => getS3JsonData('unlimited/fpc/VehicleGetFpcFamiliesAll.json').then(response => {  
    return response?.data
})
export const vehicleGetFpcFamiliesNoTest = async() => getS3JsonData('limited/fpc/VehicleGetFpcFamiliesNoTest.json').then(response => {  
    return response?.data
})
export const engineGetFpcFamiliesAll = async() => getS3JsonData('unlimited/fpc/EngineGetFpcFamiliesAll.json').then(response => {  
    return response?.data
})

export const vehicleFpcFamilyExecutionsByFamilyIdsAll = async() => getS3JsonData('unlimited/fpc/VehicleGetFpcFamilyExecutionsByFamilyIdsAll.json').then(response => {  
    return response?.data
})
export const vehicleGetFpcFamilyExecutionsByFamilyIdsNoTest = async() => getS3JsonData('limited/fpc/VehicleGetFpcFamilyExecutionsByFamilyIdsNoTest.json').then(response => {  
    return response?.data
})
export const engineFpcFamilyExecutionsByFamilyIdsAll = async() => getS3JsonData('unlimited/fpc/EngineGetFpcFamilyExecutionsByFamilyIdsAll.json').then(response => {  
    return response?.data
})

export const getDtcReportTypes = async() => getS3JsonData('dxc/getDtcReportTypes.json').then(response => {  
    return response?.data
})
export const getCpReportTypes = async() => getS3JsonData('cp/getCpReportTypes.json').then(response => {  
    return response?.data
})

export const getOperationalVariablesGUIElements = async() => getS3JsonData('ov/getOperationalVariablesGUIElements.json').then(response => {  
    return response?.data
})
export const getCdsGUIElements = async() => getS3JsonData('cds/getCdsGUIElements.json').then(response => {  
    return response?.data
})

export const ts_json = async() => getS3JsonData('ts/ts_json.json').then(response => {  
    return response?.data
})

//DYNAMIC calls
//PQ
export const getPQDepartmentsAndGroups_WHI = async() => getS3JsonData('pq/GetPQDepartmentsAndGroups_WHI.json').then(response => {  
    return response?.data
})
export const getPQDepartmentsAndGroups_Warranty = async() => getS3JsonData('pq/GetPQDepartmentsAndGroups_Warranty.json').then(response => {  
    return response?.data
})

export const getPQTGRDepartmentsAndGroups_Warranty = async() => getS3JsonData('pq/GetPQTGRDepartmentsAndGroups_Warranty.json').then(response => {
    return response?.data
})
export const getPQPartDescSubGroup_v2_WHI = async() => getS3JsonData('pq/GetPQPartDescSubGroup_v2_WHI.json').then(response => {  
    return response?.data
})
export const getPQPartDescSubGroup_v2_Warranty = async() => getS3JsonData('pq/GetPQPartDescSubGroup_v2_Warranty.json').then(response => {
    return response?.data
})
export const getPQTGRPartDescSubGroup_v2_Warranty = async() => getS3JsonData('pq/GetPQTGRPartDescSubGroup_v2_Warranty.json').then(response => {
    return response?.data
})
export const getPQPartAll_WHI = async() => getS3JsonData('pq/GetPQPartAll_WHI.json').then(response => {  
    return response?.data
})
export const getPQPartAll_Warranty = async() => getS3JsonData('pq/GetPQPartAll_Warranty.json').then(response => {  
    return response?.data
})
export const getPQTGRPartAll_Warranty = async() => getS3JsonData('pq/GetPQTGRPartAll_Warranty.json').then(response => {
    return response?.data
})
export const getPQReportTypes = async() => getS3JsonData('pq/GetPQReportTypes.json').then(response => {  
    return response?.data
})

//FF

export const vehicleSignalNamesByEcus = async() => getS3JsonData('ff/VehicleSignalNamesByEcus.json').then(response => {  
    return response?.data
})
export const engineSignalNamesByEcus = async() => getS3JsonData('ff/EngineSignalNamesByEcus.json').then(response => {  
    return response?.data
})

//ECU List
export const ffVehicleEcuApplicationsProd = async() => getS3JsonData('ff/isprod/VehicleEcuApplications.json').then(response => {  
    return response?.data
})
export const vehicleEcuApplicationsProd = async() => getS3JsonData('ecu/isprod/VehicleEcuApplications.json').then(response => {  
    return response?.data
})
export const ffEngineEcuApplicationsProd = async() => getS3JsonData('ff/isprod/EngineEcuApplications.json').then(response => {  
    return response?.data
})
export const engineEcuApplicationsProd = async() => getS3JsonData('ecu/isprod/EngineEcuApplications.json').then(response => {  
    return response?.data
})

export const vehicleSelectableDetailsByEcu = async() => getS3JsonData('ecu/isprod/VehicleSelectableDetailsByEcu.json').then(response => {  
    return response?.data
})
export const vehicleEcuEventDtc = async() => getS3JsonData('ecu/isprod/VehicleEcuEventDTC.json').then(response => {  
    return response?.data
})
export const vehicleEcuEventDec = async() => getS3JsonData('ecu/isprod/VehicleEcuEventDEC.json').then(response => {  
    return response?.data
})
export const vehicleManufacturerSparePartNo87 = async() => getS3JsonData('ecu/isprod/VehicleManufacturerSparePartNo87.json').then(response => {  
    return response?.data
})

export const vehicleManufacturerEcuSoftwareNo88 = async() => getS3JsonData('ecu/isprod/VehicleManufacturerEcuSoftwareNo88.json').then(response => {  
    return response?.data
})
export const vehicleManufacturerEcuSoftwareVersionNo89 = async() => getS3JsonData('ecu/isprod/VehicleManufacturerEcuSoftwareVersionNo89.json').then(response => {  
    return response?.data
})
export const vehicleSupplierEcuSoftwareVersionNo95 = async() => getS3JsonData('ecu/isprod/VehicleSupplierEcuSoftwareVersionNo95.json').then(response => {  
    return response?.data
})
export const engineSelectableDetailsByEcu = async() => getS3JsonData('ecu/isprod/EngineSelectableDetailsByEcu.json').then(response => {  
    return response?.data
})
export const engineEcuEventDtc = async() => getS3JsonData('ecu/isprod/EngineEcuEventDTC.json').then(response => {  
    return response?.data
})
export const engineEcuEventDec = async() => getS3JsonData('ecu/isprod/EngineEcuEventDEC.json').then(response => {  
    return response?.data
})
export const engineManufacturerSparePartNo87 = async() => getS3JsonData('ecu/isprod/EngineManufacturerSparePartNo87.json').then(response => {  
    return response?.data
})

export const engineManufacturerEcuSoftwareNo88 = async() => getS3JsonData('ecu/isprod/EngineManufacturerEcuSoftwareNo88.json').then(response => {  
    return response?.data
})
export const engineManufacturerEcuSoftwareVersionNo89 = async() => getS3JsonData('ecu/isprod/EngineManufacturerEcuSoftwareVersionNo89.json').then(response => {  
    return response?.data
})
export const engineSupplierEcuSoftwareVersionNo95 = async() => getS3JsonData('ecu/isprod/EngineSupplierEcuSoftwareVersionNo95.json').then(response => {  
    return response?.data
})
//All ecu list (Production and rest)
export const ffVehicleEcuApplicationsAll = async() => getS3JsonData('ff/all/VehicleEcuApplications.json').then(response => {  
    return response?.data
})
export const vehicleEcuApplicationsAll = async() => getS3JsonData('ecu/all/VehicleEcuApplications.json').then(response => {  
    return response?.data
})
export const ffEngineEcuApplicationsAll = async() => getS3JsonData('ff/all/EngineEcuApplications.json').then(response => {  
    return response?.data
})
export const engineEcuApplicationsAll = async() => getS3JsonData('ecu/all/EngineEcuApplications.json').then(response => {  
    return response?.data
})
export const vehicleSelectableDetailsByEcuAll = async() => getS3JsonData('ecu/all/VehicleSelectableDetailsByEcu.json').then(response => {  
    return response?.data
})
export const vehicleEcuEventDtcAll = async() => getS3JsonData('ecu/all/VehicleEcuEventDTC.json').then(response => {  
    return response?.data
})
export const vehicleEcuEventDecAll = async() => getS3JsonData('ecu/all/VehicleEcuEventDEC.json').then(response => {  
    return response?.data
})
export const vehicleManufacturerSparePartNo87All = async() => getS3JsonData('ecu/all/VehicleManufacturerSparePartNo87.json').then(response => {  
    return response?.data
})

export const vehicleManufacturerEcuSoftwareNo88All = async() => getS3JsonData('ecu/all/VehicleManufacturerEcuSoftwareNo88.json').then(response => {  
    return response?.data
})
export const vehicleManufacturerEcuSoftwareVersionNo89All = async() => getS3JsonData('ecu/all/VehicleManufacturerEcuSoftwareVersionNo89.json').then(response => {  
    return response?.data
})
export const vehicleSupplierEcuSoftwareVersionNo95All = async() => getS3JsonData('ecu/all/VehicleSupplierEcuSoftwareVersionNo95.json').then(response => {  
    return response?.data
})
export const engineSelectableDetailsByEcuAll = async() => getS3JsonData('ecu/all/EngineSelectableDetailsByEcu.json').then(response => {  
    return response?.data
})
export const engineEcuEventDtcAll = async() => getS3JsonData('ecu/all/EngineEcuEventDTC.json').then(response => {  
    return response?.data
})
export const engineEcuEventDecAll = async() => getS3JsonData('ecu/all/EngineEcuEventDEC.json').then(response => {  
    return response?.data
})
export const engineManufacturerSparePartNo87All = async() => getS3JsonData('ecu/all/EngineManufacturerSparePartNo87.json').then(response => {  
    return response?.data
})

export const engineManufacturerEcuSoftwareNo88All = async() => getS3JsonData('ecu/all/EngineManufacturerEcuSoftwareNo88.json').then(response => {  
    return response?.data
})
export const engineManufacturerEcuSoftwareVersionNo89All = async() => getS3JsonData('ecu/all/EngineManufacturerEcuSoftwareVersionNo89.json').then(response => {  
    return response?.data
})
export const engineSupplierEcuSoftwareVersionNo95All = async() => getS3JsonData('ecu/all/EngineSupplierEcuSoftwareVersionNo95.json').then(response => {  
    return response?.data
})
// TS
export const getTimeSeriesEcu = async() => getS3JsonData('ts/getTimeSeriesEcu.json').then(response => {  
    return response?.data
})

export const timeSeriesGUIElements = async() => getS3JsonData('ts/timeSeriesGUIElements.json').then(response => {  
    return response?.data
})

//OV
export const vehicleEcuFamily = async() => getS3JsonData('ov/isprod/VehicleEcuFamily.json').then(response => {  
    return response?.data
})
export const engineEcuFamily = async() => getS3JsonData('ov/isprod/EngineEcuFamily.json').then(response => {  
    return response?.data
})
export const navistarEcuFamily = async() => getS3JsonData('ov/isprod/NavistarEcuFamily.json').then(response => {  
    return response?.data
})

export const vehicleGetVariableTypesByEcuFamilies = async() => getS3JsonData('ov/isprod/VehicleGetVariableTypesByEcuFamilies.json').then(response => {  
    return response?.data
})
export const engineGetVariableTypesByEcuFamilies = async() => getS3JsonData('ov/isprod/EngineGetVariableTypesByEcuFamilies.json').then(response => {  
    return response?.data
})
export const navistarGetVariableTypesByEcuFamilies = async() => getS3JsonData('ov/isprod/NavistarGetVariableTypesByEcuFamilies.json').then(response => {  
    return response?.data
})

export const vehicleVariablesByEcuFamiliesAndVariableTypes = async() => getS3JsonData('ov/VehicleVariablesByEcuFamiliesAndVariableTypes.JSON').then(response => {  
    return response?.data
})
export const engineVariablesByEcuFamiliesAndVariableTypes = async() => getS3JsonData('ov/EngineGetVariablesByEcuFamiliesAndVariableTypes.JSON').then(response => {  
    return response?.data
})
export const navistarVariablesByEcuFamiliesAndVariableTypes = async() => getS3JsonData('ov/NavistarGetVariablesByEcuFamiliesAndVariableTypes.JSON').then(response => {  
    return response?.data
})

export const diagnosticOperationalVariables = async() => getS3JsonData('ov/getDiagnosticOperationalVariables.json').then(response => {  
    return response?.data
})

//PV

export const periodisedVariablesStaticGUIElements = async() => getS3JsonData('pv/pv_json.json').then(response => {  
    return response?.data
})
export const periodisedVariablesGUIElements = async() => getS3JsonData('pv/getPeriodisedVariablesGUIElements.json').then(response => {  
    return response?.data
})

//DXC

export const vehicleSoftwareVersionsByEcu = async() => getS3JsonData('dxc/VehicleSoftwareVersionsByEcu.json').then(response => {  
    return response?.data
})
export const engineSoftwareVersionsByEcu = async() => getS3JsonData('dxc/EngineSoftwareVersionsByEcu.json').then(response => {  
    return response?.data
})

export const vehicleEpisodeEventCount = async() => getS3JsonData('dxc/VehicleEpisodeEventCount.json').then(response => {  
    return response?.data
})
export const engineEpisodeEventCount = async() => getS3JsonData('dxc/EngineEpisodeEventCount.json').then(response => {  
    return response?.data
})
